import useModal from "@rf/base/modal/useModal";
import { ActivatePropertyTemplateModal } from "./components/ActivatePropertyTemplateModal";
import { IActivatePropertyArgs } from "./util/model";
const useActivateProperty = () => {
  const { modal } = useModal();
  const handleActivateProperty = (arg: IActivatePropertyArgs) => {
    modal({
      template: <ActivatePropertyTemplateModal />,
      data: arg,
      options: {
        title: arg.title || "Reactivar propiedad",
        size: {
          xs: {
            width: "100%",
            height: "100%"
          },
          sm: {
            width: "100%",
            height: "100%"
          },
          md: {
            width: "40vw",
            minHeight: "200px"
          },
          lg: {
            width: "40vw",
            minHeight: "200px"
          },
          xl: {
            width: "40vw",
            minHeight: "200px"
          }
        }
      }
    });
  };

  return {
    handleActivateProperty
  };
};

export default useActivateProperty;
